import { FC, useCallback, useMemo } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Button, Popover } from 'antd';
import * as React from 'react';
import { isInternalTech } from '../../utils/AuthUtils';
import {
	compareStrings,
	isAdminUser,
	nullSafeGet,
	nullSafeGetOrElse,
	recordHasContractorId,
} from '../../utils/DataAccessUtils';
import { INVOICE_STATUSES } from '../../constants/InvoiceStatuses';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { getInvoiceSubUrl } from '../invoice_utilities/InvoiceUtilities';

const InvoiceEditButton: FC<any> = ({
	userType,
	currentUser,
	history,

	ghost = false,
	invoice,
	type = 'default',
	style = { marginLeft: 12 },
}) => {
	const workOrder = useMemo(() => nullSafeGet('workOrder', invoice), [invoice]);
	const hasContractorId = useMemo(() => recordHasContractorId(invoice), [invoice]);
	const isAdmin = useMemo(() => isAdminUser(currentUser), [currentUser]);
	const isCurrentUserInvoiceSubmitter = useMemo(
		() => compareStrings(currentUser.email, nullSafeGetOrElse('createdBy', invoice, '')),
		[invoice, currentUser]
	);
	const invoicePathName = getInvoiceSubUrl(userType, currentUser, invoice);

	const isBuyerInvoice = useMemo(() => invoice.isBuyerUploaded || false, [invoice]);
	const isBuyerOrInternalTech = useMemo(
		() => userType === ROLE_TYPES.BUYER || isInternalTech(currentUser),
		[userType, currentUser]
	);
	const onClick = useCallback(
		() =>
			nullSafeGetOrElse('location.pathname', history, '').includes('/workOrders/detail/')
				? history.push(
						`/${userType}/workOrders/detail/${nullSafeGet('id', workOrder)}/invoices/${
							invoice.id
						}/edit${hasContractorId ? 'Contractor' : ''}?btwo=true`
				  )
				: history.push(
						`/${invoicePathName}/edit${hasContractorId ? 'Contractor' : ''}/${invoice.id}`
				  ),
		[history, invoice]
	);

	const buttonProps = { style, onClick, ghost, type };

	return useMemo(() => {
		switch (invoice.status) {
			case INVOICE_STATUSES.draft:
				//External Supplier can edit
				return isBuyerOrInternalTech ? null : <Button {...buttonProps}>Edit</Button>;

			case INVOICE_STATUSES.pending:
				if (isBuyerOrInternalTech) {
					if (isBuyerInvoice) {
						if (isAdmin || isCurrentUserInvoiceSubmitter) {
							return <Button {...buttonProps}>Edit</Button>;
						} else {
							return null;
						}
					} else {
						return (
							<Popover
								content={'You can only edit invoices submitted by your company.'}
								placement={'left'}
							>
								<Button {...buttonProps} disabled={true}>
									Edit
								</Button>
							</Popover>
						);
					}
				} else {
					return (
						<Popover
							content={'Invoice must be moved back to draft status to edit it.'}
							placement={'left'}
						>
							<Button {...buttonProps} disabled={true}>
								Edit
							</Button>
						</Popover>
					);
				}
			case INVOICE_STATUSES.disputed:
				if (isBuyerOrInternalTech) {
					if (isBuyerInvoice) {
						if (isAdmin || isCurrentUserInvoiceSubmitter) {
							return <Button {...buttonProps}>Edit</Button>;
						} else {
							return null;
						}
					} else {
						return (
							<Popover
								content={'You can only edit invoices submitted by your company.'}
								placement={'left'}
							>
								<Button {...buttonProps} disabled={true}>
									Edit
								</Button>
							</Popover>
						);
					}
				} else {
					return <Button {...buttonProps}>Edit</Button>;
				}
			default:
				if (isBuyerOrInternalTech) {
					if (isBuyerInvoice) {
						if (isAdmin || isCurrentUserInvoiceSubmitter) {
							return (
								<Popover
									content={'Move this invoice back to pending status to edit it.'}
									placement={'left'}
									trigger={'hover'}
								>
									<Button {...buttonProps} disabled={true}>
										Edit
									</Button>
								</Popover>
							);
						} else {
							return null;
						}
					} else {
						return (
							<Popover
								content={'You can only edit invoices submitted by your company.'}
								placement={'left'}
							>
								<Button {...buttonProps} disabled={true}>
									Edit
								</Button>
							</Popover>
						);
					}
				} else {
					return (
						<Popover
							content={'Invoice must be moved back to draft status to edit it.'}
							placement={'left'}
						>
							<Button {...buttonProps} disabled={true}>
								Edit
							</Button>
						</Popover>
					);
				}
		}
	}, [isBuyerInvoice, isBuyerOrInternalTech, isAdmin, isCurrentUserInvoiceSubmitter, invoice]);
};

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
	history: ownProps.history,
});

const ComponentWithoutUserType = withRouter(connect(mapStateToProps, {})(InvoiceEditButton));

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
